module.exports = __webpack_public_path__ + "static/img/40014 (1).2f3630d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40014 (1).webp
// module id = Ljhu
// module chunks = 14